<footer class="app-footer">
  <img
    src="images/logos/TrendsicLogo_Owl_NoWords.svg"
    class="footer-logo"
    alt="Trendsic"
    width="135"
    height="auto" />
</footer>
